if(!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();

      const end = parseInt(this.getAttribute('data-end-date'));
      const endtime = new Date(end * 1000);
      const init = this.get(endtime);
      this.update(init);

      const timer = setInterval(() => {
        const t = this.get(endtime);
        this.update(t);               

        if (t.total <= 0) {
          clearInterval(timer);
        }
      }, 1000);

      document.querySelectorAll('.countdown--animate-hold').forEach(el => {
        el.classList.add('countdown--animate-in');
      });
    }

    get(endtime) {
      const text_after_countdown = this.getAttribute('data-text-after-countdown');
      const total = endtime - Date.parse(new Date());
      const seconds = Math.floor((total/1000) % 60);
      const minutes = Math.floor((total/1000/60) % 60);
      const hours = Math.floor((total/(1000*60*60)) % 24);
      const days = Math.floor(total/(1000*60*60*24));

      return {
        total,
        days,
        hours,
        minutes,
        seconds
      };
    }

    update(t) {
      if (t.total <= 0) {
        const text_after_countdown = this.getAttribute('data-text-after-countdown');
        if (text_after_countdown) {
          this.innerHTML = text_after_countdown;
        }
        return;
      }

      let parts = [];
      
      if(t.days > 0) {
        parts.push(`<span>${t.days}</span> d`);
      }
      
      if(t.hours > 0 || t.days > 0) {
        parts.push(`<span>${this.pad(t.hours)}</span> h`);
      }
      
      parts.push(`<span>${this.pad(t.minutes)}</span> min`);
      parts.push(`<span>${this.pad(t.seconds)}</span> s`);
      
      this.innerHTML = parts.join(' ');
    }

    pad(num) {
      let s = "0" + num;
      return s.substring(s.length-2, s.length);
    }
  }   

  customElements.define('countdown-timer', CountdownTimer);
}